export default class SelectCustomBindings {
    constructor(calendar) {
        this.calendar = calendar;
        this.selectCustomClassname = '_js-select-custom';
        this.$selectCustom = $('.' + this.selectCustomClassname);

        this.closeSelect();
    }

    closeSelect() {
        $(document).on('click', (e) => {
            let $currentElement = $(e.target),
                $details = $currentElement.closest('.' + this.selectCustomClassname);

            if ($details.length) return;

            this.hideDetails();
        });

        $(document).keyup((e) => {
            if(e.keyCode === 27) {
                this.hideDetails();
            }
        });
    }

    hideDetails() {
        this.$selectCustom.each((i, element) => {
            if ($(element).find('.calendar').length && $(element).attr('open')) {
                let $calendar = $(element).find('.calendar'),
                    startDate = $calendar.attr('data-start'),
                    endDate = $calendar.attr('data-end');

                this.calendar.calendars[0].set_date([startDate, endDate]);
            }
            $(element).removeAttr('open');
        });
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/select-custom/SelectCustomBindings.js